export default {
  Title: 'Voice Interview',
  Subtitle: 'Complete your caregiver application with a brief interview with our AI assistant',
  Status: {
    Connecting: 'Connecting...',
    AISpeaking: 'AI is Speaking...',
    AIListening: 'AI is Listening...',
    Completed: 'Interview Completed',
    ReadyToStart: 'Ready to Start',
  },
  Duration: 'Duration: #{duration}',
  ReadyToStart: {
    Title: 'Ready to start your interview?',
    Instructions: 'This interview will take about 5-10 minutes. Make sure you\'re in a quiet environment and have a stable internet connection.',
    StartButton: 'Start Interview',
  },
  Connecting: {
    Title: 'Connecting to interview agent...',
    Message: 'Please wait while we establish the connection',
  },
  InProgress: {
    Title: 'Interview in progress',
    Instructions: 'The AI assistant is asking you questions about your caregiving experience. Speak clearly and take your time to answer.',
    EndButton: 'End Interview',
  },
  Completed: {
    Title: 'Interview Completed Successfully!',
    Message: 'Thank you for completing the interview. Your responses have been recorded and will be reviewed as part of your application process.',
  },
  Guidelines: {
    Title: 'Interview Guidelines',
    QuietEnvironment: '• Ensure you\'re in a quiet environment',
    SpeakClearly: '• Speak clearly and at a normal pace',
    BeHonest: '• Be honest and provide specific examples when possible',
    CoverTopics: '• The interview will cover your experience, availability, and motivations',
  },
};
